import { computeDownTransLabel } from "@/models/equipment/step_down_transformer/properties";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderStepDownXfmrCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  {
    section: "S/D XFMR",
    label: "XFMR Description",
    targetUnit: null,
    value: computeDownTransLabel(
      scenario.equipment.value?.r_step_down_transformer
    )
  },
  {
    section: "S/D XFMR",
    label: "Surface Required Volts",
    targetUnit: targetUnits.voltageUnit,
    value: scenario.parameters.value?.surface_drive_incoming_power_volts
  }
];
